import React from 'react';
import { FormattedMessage } from "react-intl";
import './Eingabe.css';

class EingabeKulissentyp extends React.Component {
    constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    }

  handleChange(event) {
        this.props.SelectedKulissentyp(event.target.value);
  }

  render() {

    return (
        <div>
          <label>
              <FormattedMessage id="Kulissentyp" /> [mm]</label>
              <select value={this.props.value} onChange={this.handleChange} disabled={this.props.disabledChecked}>
                  <FormattedMessage id="HKS_Kulisse_Standard">{(msg)=><option key={1} value='HKS'>{msg}</option>}</FormattedMessage>
                  <FormattedMessage id="HKR_Kulisse_mit_Resonanzblech">{(msg)=><option key={2} value='HKR'>{msg}</option>}</FormattedMessage>
                  <FormattedMessage id="HKL_Kulisse_mit_Lochblech">{(msg)=>    <option key={3} value='HKL'>{msg}</option>}</FormattedMessage>
                  <FormattedMessage id="HKRL_Kulisse_Resonanz_und_Lochblech">{(msg)=>    <option key={4} value='HKRL'>{msg}</option>}</FormattedMessage>
                  {/*<option key={5} value='HKRR'>HKRR</option>*/}


              </select>

          {/*<p>{this.state.value}</p>*/}
        </div>
    );
  }
}
export default EingabeKulissentyp;
